import {
    Avatar,
    Flex,
    Grid,
    Header,
    pxArrayToRem,
    pxToRem,
    useStyles,
} from '@archipro-design/aria';
import * as S from './Heading.style';
import type { ProductPageLoaderData } from '~/routes/_app.product.$urlSegment';
import { Link } from '@remix-run/react';

interface HeadingProps {
    data: ProductPageLoaderData['product']['Professional'];
}

const Heading = ({ data }: HeadingProps) => {
    const logo = data?.CompanyLogo;
    const logoBackgroundColor = data?.LogoBackgroundColor || 'white';
    const { css } = useStyles();

    return (
        <Flex column={false} vAlign="center" className={css(S.HeaderContainer)}>
            <Flex
                column={false}
                vAlign="center"
                className={css(S.HeaderContainerInner)}
            >
                <Grid
                    columns={pxArrayToRem([880, 896])}
                    className={css({
                        columnGap: pxToRem(44),
                    })}
                >
                    <Header as="h3" variant="03" className={css(S.Header)}>
                        About the
                        <br />
                        Seller
                    </Header>

                    {logo && (
                        <div className={css(S.CompanyLogoWrapper)}>
                            <div className={css(S.CompanyLogoContainer)}>
                                <Avatar
                                    as={Link}
                                    to={data.Link}
                                    image={{
                                        src: logo ?? '',
                                        alt: `${data.Title} company logo`,
                                        loading: 'lazy',
                                    }}
                                    initials={'Logo'}
                                    size={230}
                                    imageFit={'contain'}
                                    styles={{
                                        borderWidth: 0,
                                    }}
                                    shape={'square'}
                                    variables={{
                                        avatarImageBackgroundColor:
                                            logoBackgroundColor,
                                        borderRadius: '0',
                                    }}
                                />
                            </div>
                        </div>
                    )}
                </Grid>
            </Flex>
        </Flex>
    );
};

export default Heading;
